/**
 * Interface for job types
 */
export interface JobType {
  code: string;
  name: string;
}

/**
 * List of all job types
 */
export const JOB_TYPES: JobType[] = [
  { code: 'ARB', name: 'Arbitration' },
  { code: 'AUD', name: 'Audio Transcription' },
  { code: 'CAN', name: 'Cancellation' },
  { code: 'CNA', name: 'Certificate of Non-Appearance' },
  { code: 'DEP', name: 'Deposition' },
  { code: 'EUO', name: 'EUO' },
  { code: 'HRG', name: 'Hearing' },
  { code: 'MTG', name: 'Meeting' },
  { code: 'NTS', name: 'Non-Transcribe' },
  { code: 'SOR', name: 'Statement on the Record' },
  { code: 'TRL', name: 'Trial' }
];

export default JOB_TYPES;